import { render, staticRenderFns } from "./UploadMap.vue?vue&type=template&id=63596091"
import script from "./UploadMap.vue?vue&type=script&lang=js"
export * from "./UploadMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports